import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {DatePicker, RadioButtonQuestion} from "../../../components/forms";
import {InlineDiv} from "../../../components";

const Container = styled.div`
  
`;

const Level2Form = ({onChange, form}) => (
  <Container>
    <p>
      A Level II Evaluation and determination is only required when: 
      The provider has indicated "yes" to any question in Part A or B of the DHS 1178 Form, and no exemptions indicated. 
      The recipient has remained inpatient at the facility beyond the time constraints of an exemption. 
      If no level II evaluation is required this section is N/A. Proceed to Resident Review section of the worksheet. 
    </p>
    <ol start={8}>
      <li>
        <RadioButtonQuestion
          id={'q8'}
          value={form['q8'].value}
          onChange={onChange('q8')}
          items={RadioButtonQuestion.YesNoNotApplicable}
          question="Was a Level II screen completed within the appropriate timeframe?"
          error={!form['q8'].hasError ? null : true}
          disabled={form['q8'].disabled}
        >
          <InlineDiv>
            <DatePicker
              value={form['q8date'].value}
              onChange={onChange('q8date')}
              error={!form['q8date'].hasError ? null : true}
              disabled={form['q8date'].disabled}
            />
          </InlineDiv>
        </RadioButtonQuestion>
      </li>
      <li>
        <RadioButtonQuestion
          id={'q9'}
          value={form['q9'].value}
          onChange={onChange('q9')}
          items={RadioButtonQuestion.YesNoNotApplicable}
          question="Is there a letter of determination by the MHA?"
          error={!form['q9'].hasError ? null : true}
          disabled={form['q9'].disabled}
        >
          <InlineDiv>
            <DatePicker
              value={form['q9date'].value}
              onChange={onChange('q9date')}
              error={!form['q9date'].hasError ? null : true}
              disabled={form['q9date'].disabled}
            />
          </InlineDiv>
        </RadioButtonQuestion>
      </li>
      <li>
        <RadioButtonQuestion
          id={'q10'}
          value={form['q10'].value}
          onChange={onChange('q10')}
          items={RadioButtonQuestion.YesNoNotApplicable}
          question="Did the MHA complete the Level II determination within 9 working days?"
          error={!form['q10'].hasError ? null : true}
          disabled={form['q10'].disabled}
        >
          <InlineDiv>
            <DatePicker
              value={form['q10date'].value}
              onChange={onChange('q10date')}
              error={!form['q10date'].hasError ? null : true}
              disabled={form['q10date'].disabled}
            />
          </InlineDiv>
        </RadioButtonQuestion>
      </li>
      <li>
        <RadioButtonQuestion
          id={'q11'}
          value={form['q11'].value}
          onChange={onChange('q11')}
          items={RadioButtonQuestion.YesNoNotApplicable}
          question="If specialized services were required, were the specialized services provided?"
          error={!form['q11'].hasError ? null : true}
          disabled={form['q11'].disabled}
        >
          <InlineDiv>
            <DatePicker
              value={form['q11date'].value}
              onChange={onChange('q11date')}
              error={!form['q11date'].hasError ? null : true}
              disabled={form['q11date'].disabled}
            />
          </InlineDiv>
        </RadioButtonQuestion>
      </li>
    </ol>
  </Container>
)

Level2Form.propTypes = {
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Level2Form;



// WEBPACK FOOTER //
// ./src/modules/record/components/Level2Form.js